'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var avatarCache = {};

exports.default = {
    props: ['message', 'user', 'size'],

    data: function data() {
        return {
            avatarUrl: ''
        };
    },
    mounted: function mounted() {
        if (this.hasAvatar) {
            this.avatarUrl = this.size === 'small' && this.avatar.small ? this.avatar.small : this.avatar.large;
            return;
        }

        this.checkStatsAvatar();
    },


    computed: {
        statsAvatarUrl: function statsAvatarUrl() {
            var nick = this.message && this.message.nick || this.user && this.user.nick || '';

            return 'https://stats.brasirc.com.br/' + encodeURIComponent(nick.toLowerCase());
        },
        avatar: function avatar() {
            return this.message && this.message.avatar || this.user && this.user.avatar;
        },
        firstNickLetter: function firstNickLetter() {
            return (this.message && this.message.nick || this.user && this.user.nick || '')[0];
        },
        hasAvatar: function hasAvatar() {
            return !!(this.avatar && (this.avatar.small || this.avatar.large));
        },
        avatarStyle: function avatarStyle() {
            var style = {};
            var url = '';

            url = this.avatarUrl;

            if (url) {
                style['background-image'] = 'url("' + url + '")';
            } else {
                style['background-color'] = '' + this.colour;
            }

            return style;
        },
        colour: function colour() {
            var user = this.message && this.message.user || this.user;
            return user.getColour();
        }
    },

    methods: {
        checkStatsAvatar: function checkStatsAvatar() {
            var _this = this;

            if (avatarCache[this.statsAvatarUrl]) {
                this.avatarUrl = avatarCache[this.statsAvatarUrl];
                return;
            }
            var img = new Image();

            img.onload = function () {
                avatarCache[_this.statsAvatarUrl] = _this.statsAvatarUrl;
                _this.avatarUrl = _this.statsAvatarUrl;
            };

            img.onerror = function () {
                avatarCache[_this.statsAvatarUrl] = 'https://stats.brasirc.com.br/brasirc';
                _this.avatarUrl = 'https://stats.brasirc.com.br/brasirc';
            };

            img.src = this.statsAvatarUrl;
        }
    }

};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Avatar"]
window._kiwi_exports.components.Avatar = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Avatar.vue
// module id = 2Mov
// module chunks = 1